import React from 'react'
import styled from 'styled-components'
import Logic from './logic'
import axios from 'axios'

import ArrowIcon from './images/ic-arrow.component.svg'
import Person from './images/person.component.svg'
import IcCar from './images/ic-eletric-car.component.svg'
import IcSolar from './images/ic-solar.component.svg'
import IcGas from './images/ic-gas.component.svg'

import FormV2 from 'containers/FormV2'
import SectionV2 from 'components/SectionV2'
import SectionMobileV2 from 'components/SectionMobileV2'
import InlineRadioV2 from 'components/InlineRadioV2'
import InlineCheckV2 from 'components/InlineCheckV2'
import LeftAlignRadioV2 from 'components/LeftAlignRadioV2'
import LeftAlignCheckV2 from 'components/LeftAlignCheckV2'
import Loading from 'components/Loading'
import Select from 'components/SelectV2'
import SectionHeader from 'components/SectionHeader'
import FixedWrapper from 'components/FixedWrapper'
import { pickOrNot } from 'utils'
import { Messages } from 'validations'
import { GOOGLE_KEY } from 'config'
import uniqBy from 'lodash/uniqBy'

const GEO_LOCATION_OPTIONS = {
  maximumAge: 0,
}

/* eslint-disable camelcase */
@Logic
export default class ProfileV2 extends FormV2 {
  state = {
    nextText: `Ver Resultados`,
    width: 0,
  }

  componentDidMount() {
    const { currentLocalization, values } = this.props

    if (!currentLocalization && !values.district && !values.municipality) {
      navigator.geolocation.getCurrentPosition(
        this.geoSucess,
        this.geoError,
        GEO_LOCATION_OPTIONS
      )
    }

    // Scrols to top on component mount
    const element = document.getElementById('anchor')

    window.scroll({
      top: element.getBoundingClientRect().top,
    })

    this.handleResize(true)
    window.addEventListener('resize', this.handleResize)
  }

  componentDidUpdate(oldProps) {
    if (oldProps.loading && !this.props.loading) {
      const element = document.getElementById('anchor')

      window.scroll({
        top: element.getBoundingClientRect().top,
      })
    }

    const errorElement = document.querySelector('span[data-error]')
    if (errorElement) {
      if (errorElement.parentElement) {
        errorElement.parentElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      } else {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }

    this.handleResize(false)
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  sendHeight = () => {
    const height = document.body.scrollHeight
    window.parent.postMessage({ type: 'setHeight', height }, '*')
  }

  handleResize = (updateState) => {
    updateState && this.updateWindowDimensions()
    this.sendHeight()
  }

  geoError = (error) => true

  geoSucess = (position) => {
    const { setCurrentLocation } = this.actions
    let lat
    let long

    lat = position.coords && position.coords.latitude
    long = position.coords && position.coords.longitude

    const GOOGLE_GEO_API = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&sensor=true&key=${GOOGLE_KEY}`

    try {
      const request = axios.get(GOOGLE_GEO_API)

      request.then((result) => {
        if (
          result.data.error_message ||
          result.data.status === 'OVER_QUERY_LIMIT' ||
          result.data.status === 'ZERO_RESULTS'
        ) {
          return false
        }

        let newArr = []
        result.data.results.forEach((component) => {
          newArr = [...newArr, ...component.address_components]
        })
        newArr = uniqBy(newArr, 'long_name')

        setCurrentLocation(newArr)
      })
    } catch (error) {}
  }

  /**
   * Renders invalid messags
   */
  renderInvalidMessage = (invalid, field, name) => {
    if (invalid) {
      if (invalid[field]) {
        const Message = Messages[invalid[field]]
        if (Message) {
          return <Error data-error>{Message(name)}</Error>
        }
      }
    }

    return null
  }

  /**
   * Submits the form
   */
  submit = () => {
    const { valid, invalid } = this.isFormValid()
    const { setFinished, setInvalid, setCurrentLocation } = this.actions
    const { router } = this.props

    if (valid) {
      setFinished({ profileFinished: true })
      setInvalid({})
      window.parent.postMessage({ type: 'scrollToTop' }, '*')

      setCurrentLocation([])
      router.push('/resultados')
    } else {
      setFinished({ profileFinished: false })
      setInvalid(invalid)
    }
  }

  render() {
    const { districts, cities, loading, invalid, iframed, values } = this.props

    const { setValues, fetchCities } = this.actions

    const { offerTypes } = this.props.data

    const {
      offerType,
      municipality,
      district,
      habitants,
      hasSolarSystem,
      hasNaturalGasHeating,
      hasElectricCar,
    } = this.props.values

    const citiesDisabled = !district || !cities

    let locationInvalid = pickOrNot(invalid, ['district', 'municipality'])
    let habitantsInvalid = pickOrNot(invalid, ['habitants'])

    if (loading) {
      return <Loading />
    }

    // All sections of this page
    const SimulateSection =
      this.state.width > 1000 ? (
        <SectionV2
          title={`Tipo de Simulação`}
          key={`simulate`}
          compact={iframed}>
          <ButtonContainer>
            {offerTypes &&
              offerTypes.map(({ icon, text, value }, index) => (
                <InlineRadioV2
                  key={`ot-${index}`}
                  onClick={() => {
                    if (value === 2) {
                      setValues({ hasNaturalGasHeating: false })
                    }
                    setValues({ offerType: value })
                  }}
                  icon={icon}
                  name={text}
                  selected={offerType === value}
                />
              ))}
          </ButtonContainer>
        </SectionV2>
      ) : (
        <SectionMobileV2
          title={`Tipo de Simulação`}
          key={`simulate`}
          compact={iframed}>
          <StyledSelect
            items={offerTypes.map((item) => ({
              value: item.value,
              label: item.text,
            }))}
            onChange={({ value }) => {
              if (value === 2) {
                setValues({ hasNaturalGasHeating: false })
              }
              setValues({ offerType: value })
            }}
            selected={offerType}
            arrowIcon={ArrowIcon}
          />
        </SectionMobileV2>
      )

    const GeneralSection =
      this.state.width > 1000 ? (
        <SectionV2 title={`Informação Geral`} key={`general`} compact={iframed}>
          <GeneralWrapper>
            <InsideSection id='location' key={`location`}>
              <SectionHeader title={`Localização`} />
              <LocationInputsWrapper>
                <WrapperSelect>
                  <InputLabel>
                    Distrito <b>*</b>
                  </InputLabel>
                  <StyledSelect
                    placeholder={'Distrito'}
                    items={districts}
                    onChange={({ value }) => {
                      setValues({ district: value, municipality: undefined })
                      fetchCities(value)
                    }}
                    selected={district}
                    arrowIcon={ArrowIcon}
                  />
                  {this.renderInvalidMessage(
                    locationInvalid,
                    'district',
                    'Distrito'
                  )}
                </WrapperSelect>

                <WrapperSelect>
                  <InputLabel>Concelho</InputLabel>
                  <StyledSelect
                    disabled={citiesDisabled}
                    placeholder={'Concelho'}
                    items={cities}
                    onChange={({ value }) => setValues({ municipality: value })}
                    selected={municipality}
                    arrowIcon={ArrowIcon}
                  />
                  {this.renderInvalidMessage(
                    locationInvalid,
                    'municipality',
                    'Concelho'
                  )}
                </WrapperSelect>
              </LocationInputsWrapper>
            </InsideSection>

            <InsideSection>
              <SectionHeader
                title={`Agregado Familiar`}
                subTitle={`Por favor, selecione um cenário.`}
              />
              <InputsWrapper>
                <LeftAlignRadioV2
                  onClick={() => {
                    setValues({ habitants: 1 })
                  }}
                  icon={
                    <PersonIconWrapper>
                      <Person /> <span>1</span>{' '}
                    </PersonIconWrapper>
                  }
                  name='1 Pessoa'
                  selected={habitants === 1}
                />
                <LeftAlignRadioV2
                  onClick={() => {
                    setValues({ habitants: 2 })
                  }}
                  icon={
                    <PersonIconWrapper>
                      <Person /> <span>2</span>{' '}
                    </PersonIconWrapper>
                  }
                  name='2 Pessoas'
                  selected={habitants === 2}
                />
                <LeftAlignRadioV2
                  onClick={() => {
                    setValues({ habitants: 3 })
                  }}
                  icon={
                    <PersonIconWrapper>
                      <Person /> <span>3</span>{' '}
                    </PersonIconWrapper>
                  }
                  name='3 Pessoas'
                  selected={habitants === 3}
                />
                <LeftAlignRadioV2
                  onClick={() => {
                    setValues({ habitants: 4 })
                  }}
                  icon={
                    <PersonIconWrapper>
                      <Person /> <span>4</span>{' '}
                    </PersonIconWrapper>
                  }
                  name='4 Pessoas'
                  selected={habitants === 4}
                />
                <LeftAlignRadioV2
                  onClick={() => {
                    setValues({ habitants: 5 })
                  }}
                  icon={
                    <PersonIconWrapper>
                      <Person /> <span>5</span>{' '}
                    </PersonIconWrapper>
                  }
                  name='5 ou mais pessoas'
                  selected={habitants === 5}
                />
              </InputsWrapper>
              {this.renderInvalidMessage(
                habitantsInvalid,
                'habitants',
                'Agregado Familiar'
              )}
            </InsideSection>

            <InsideSection>
              <SectionHeader
                title={`Opções Adicionais`}
                required={false}
                subTitle={`Por favor, selecione uma ou várias opções.`}
              />
              <InputsWrapper>
                <LeftAlignCheckV2
                  onClick={() => {
                    setValues({ hasElectricCar: !hasElectricCar })
                  }}
                  icon={<IcCar />}
                  name='Carro Elétrico'
                  selected={hasElectricCar}
                />
                <LeftAlignCheckV2
                  onClick={() => {
                    setValues({ hasSolarSystem: !hasSolarSystem })
                  }}
                  icon={<IcSolar />}
                  name='Energias Renováveis'
                  selected={hasSolarSystem}
                />
                <LeftAlignCheckV2
                  disabled={values.offerType === 2}
                  onClick={() => {
                    setValues({ hasNaturalGasHeating: !hasNaturalGasHeating })
                  }}
                  icon={<IcGas />}
                  name='Aquecimento centralizado a Gás Natural'
                  selected={hasNaturalGasHeating}
                />
              </InputsWrapper>
            </InsideSection>
          </GeneralWrapper>
        </SectionV2>
      ) : (
        <SectionMobileV2
          title={`Informação Geral`}
          key={`general`}
          compact={iframed}>
          <MobileGeneralWrapper>
            <MobileSection>
              <SectionHeader title={`Localização`} />
              <WrapperSelect style={{ width: '100% ' }}>
                <InputLabel>
                  Distrito <b>*</b>
                </InputLabel>
                <StyledSelect
                  placeholder={'Distrito'}
                  items={districts}
                  onChange={({ value }) => {
                    setValues({ district: value, municipality: undefined })
                    fetchCities(value)
                  }}
                  selected={district}
                  arrowIcon={ArrowIcon}
                />
                {this.renderInvalidMessage(
                  locationInvalid,
                  'district',
                  'Distrito'
                )}
              </WrapperSelect>

              <WrapperSelect style={{ width: '100% ' }}>
                <InputLabel>Concelho</InputLabel>
                <StyledSelect
                  disabled={citiesDisabled}
                  placeholder={'Concelho'}
                  items={cities}
                  onChange={({ value }) => setValues({ municipality: value })}
                  selected={municipality}
                  arrowIcon={ArrowIcon}
                />
                {this.renderInvalidMessage(
                  locationInvalid,
                  'municipality',
                  'Concelho'
                )}
              </WrapperSelect>
            </MobileSection>

            <MobileSection>
              <SectionHeader
                title={`Agregado Familiar`}
                subTitle='Por favor, selecione um cenário.'
              />
              <MobileSection style={{ gap: '8px' }}>
                <InlineRadioV2
                  style={{ width: '100%' }}
                  onClick={() => {
                    setValues({ habitants: 1 })
                  }}
                  icon={
                    <PersonIconWrapper>
                      <Person /> <span>1</span>{' '}
                    </PersonIconWrapper>
                  }
                  name='1 Pessoa'
                  selected={habitants === 1}
                />
                <InlineRadioV2
                  style={{ width: '100%' }}
                  onClick={() => {
                    setValues({ habitants: 2 })
                  }}
                  icon={
                    <PersonIconWrapper>
                      <Person /> <span>2</span>{' '}
                    </PersonIconWrapper>
                  }
                  name='2 Pessoas'
                  selected={habitants === 2}
                />
                <InlineRadioV2
                  style={{ width: '100%' }}
                  onClick={() => {
                    setValues({ habitants: 3 })
                  }}
                  icon={
                    <PersonIconWrapper>
                      <Person /> <span>3</span>{' '}
                    </PersonIconWrapper>
                  }
                  name='3 Pessoas'
                  selected={habitants === 3}
                />
                <InlineRadioV2
                  style={{ width: '100%' }}
                  onClick={() => {
                    setValues({ habitants: 4 })
                  }}
                  icon={
                    <PersonIconWrapper>
                      <Person /> <span>4</span>{' '}
                    </PersonIconWrapper>
                  }
                  name='4 Pessoas'
                  selected={habitants === 4}
                />
                <InlineRadioV2
                  style={{ width: '100%' }}
                  onClick={() => {
                    setValues({ habitants: 5 })
                  }}
                  icon={
                    <PersonIconWrapper>
                      <Person /> <span>5</span>{' '}
                    </PersonIconWrapper>
                  }
                  name='5 ou mais pessoas'
                  selected={habitants === 5}
                />
              </MobileSection>
              {this.renderInvalidMessage(
                habitantsInvalid,
                'habitants',
                'Agregado Familiar'
              )}
            </MobileSection>

            <MobileSection>
              <SectionHeader
                title={`Opções Adicionais`}
                required={false}
                subTitle='Por favor, selecione uma ou várias opções.'
              />
              <InlineCheckV2
                style={{ width: '100%' }}
                onClick={() => {
                  setValues({ hasElectricCar: !hasElectricCar })
                }}
                icon={<IcCar />}
                name='Carro Elétrico'
                selected={hasElectricCar}
              />
              <InlineCheckV2
                style={{ width: '100%' }}
                onClick={() => {
                  setValues({ hasSolarSystem: !hasSolarSystem })
                }}
                icon={<IcSolar />}
                name='Energias Renováveis'
                selected={hasSolarSystem}
              />
              <InlineCheckV2
                disabled={values.offerType === 2}
                style={{ width: '100%' }}
                onClick={() => {
                  setValues({ hasNaturalGasHeating: !hasNaturalGasHeating })
                }}
                icon={<IcGas />}
                name='Aquecimento centralizado a Gás Natural'
                selected={hasNaturalGasHeating}
              />
            </MobileSection>
          </MobileGeneralWrapper>
        </SectionMobileV2>
      )

    return (
      <div>
        <FixedWrapper>
          {SimulateSection}
          {GeneralSection}
        </FixedWrapper>
        <Message>
          <p>
            A simulação tem por base consumos típicos para as opções
            selecionadas e preços do mercado regulado. Para adaptar a simulação
            aos seus consumos introduza os seus dados na opção{' '}
            <b>“Ajustar Valores”</b> do menu seguinte.
          </p>
        </Message>
        {this.renderSubmitButton()}
      </div>
    )
  }
}

const GeneralWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
`

const MobileGeneralWrapper = styled(GeneralWrapper)`
  gap: 16px;
  align-self: stretch;
  justify-content: unset;
  background: #fff;
`

const MobileSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

const InsideSection = styled.div`
  display: flex;
  padding-bottom: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

const LocationInputsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

const InputsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
`

const PersonIconWrapper = styled.div`
  display: flex;
  width: 26px;
  height: 26px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  position: relative;

  > svg {
    width: 26px !important;
    height: 26px !important;
  }

  > span {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-shrink: 0;
    position: absolute;
    top: 26%;
    right: 28%;
    color: #3e3e3e;
    text-align: center;
    font-family: Nunito;
    font-size: 8px;
    font-style: normal;
    font-weight: 800;
    line-height: 14px;

    font-size: 8px;
  }

  @media screen and (min-width: 1000px) {
    width: 36px;
    height: 36px;

    > svg {
      width: 36px !important;
      height: 36px !important;
    }

    > span {
      top: 33%;
      right: 26%;
    }
  }
`

const WrapperSelect = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  min-width: 270px;
`

const StyledSelect = styled(Select)`
  width: 100%;
  max-width: initial;

  > div:first-child {
    height: 40px;
  }

  > div {
    padding: 10px;
    border: 1px solid #bababa;

    color: #616161;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
  }
  ${({ margin }) => margin && `margin-right: 30px;`}
`

const InputLabel = styled.label`
  height: 25px;
  align-self: stretch;
  color: #3e3e3e;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  > b {
    overflow: hidden;
    color: #f00;
    font-feature-settings: 'liga' off, 'clig' off;
    text-overflow: ellipsis;
    font-family: Nunito;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 200% */
    letter-spacing: 1px;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  width: 100%;
`

const Message = styled.div`
  display: flex;
  padding: 16px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  p,
  b {
    color: #3e3e3e;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    margin: 0;
  }

  b {
    font-weight: 700;
  }

  @media screen and (min-width: 750px) {
    padding-inline: 130px;
  }
`

const Error = styled.span`
  display: inline-block;
  font-size: 12px;
  color: indianred;
  margin: 10px auto;
  text-align: left;
`



// WEBPACK FOOTER //
// ./src/containers/ProfileV2/index.js